import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetAllColorsForSampleCard(
  sampleCardId: number
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/colors/${sampleCardId}`);
}

export function apiGetAllColorsForSampleCardAndProduct(
  sampleCardId: number,
  productId:number,
  onlySpecialReceipts:boolean
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/colorsWithExistingReceipt/${sampleCardId}/${productId}/${onlySpecialReceipts}`);
}

export function apiGetAllColorsForSampleCardAndProductAndBase(
  sampleCardId: number,
  productId:number,
  baseId:number
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/colorsWithExistingReceiptForProductAndBase/${sampleCardId}/${productId}/${baseId}`);
}



export function apiGetColorDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/color/${id}`);
}

export function apiColorCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/colorcreateorupdate`, data);
}

export function apiDeleteColor(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/color/${id}`);
}

export function apiUpdatePictureName(id: number, fileName: string): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/color/${id}/picture/${fileName}`);
}
